import { useNavigate } from "react-router";
import "./StoryContainer.scss";

import { useState } from "react";
import Button from "../../components/Button/Button";
import Layout from "../../components/Layout/Layout";
import storyData from "../../data/storyData";
import NeedsContainer from "../../components/NeedsContainer/NeedsContainer";

const StoryContainer = () => {
  const [counter, setCounter] = useState(0);
  const navigate = useNavigate();
  const LAST_STORY_ELEMENT = storyData.length - 1;

  const handleIncrement = () => {
    if (counter == LAST_STORY_ELEMENT) {
      navigate("/swing-game/play/1");
    } else {
      setCounter(counter + 1);
    }
  };

  const handleDecrement = () => {
    if (counter > 0) {
      setCounter(counter - 1);
    }
  };

  return (
    <Layout requiresAuth={true}>
      <div
        className="story-container"
        style={{
          backgroundImage: `url(${storyData[counter].image})`,
        }}
      >
        <div
          className={
            "story-container__needs-container " +
            (counter == 5
              ? "story-container__needs-container--highlighted"
              : "")
          }
        >
          <NeedsContainer />
        </div>
        <p className="story-container__text">{storyData[counter].story}</p>
        <div className="story-container__button-container">
          <Button label={"NEXT"} onClick={handleIncrement} />
          {counter > 0 && <Button label={"BACK"} onClick={handleDecrement} />}
        </div>
      </div>
    </Layout>
  );
};

export default StoryContainer;
